// Imports
var ___CSS_LOADER_API_IMPORT___ = require("C:\\Users\\91973\\AppData\\Roaming\\npm\\node_modules\\expo-cli\\node_modules\\css-loader\\dist\\runtime\\api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vertical-timeline.vertical-timeline-custom-line::before {\r\n  background: #631A6E;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
